var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseAdviserPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6059 9.33333V7.91667C20.6059 7.13426 20.0985 6.5 19.4726 6.5H5.87259C5.24667 6.5 4.73926 7.13426 4.73926 7.91667V22.0833C4.73926 22.8657 5.24667 23.5 5.87259 23.5H19.4726C20.0985 23.5 20.6059 22.8657 20.6059 22.0833V14.4333",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1502 13.4722C17.9582 13.5814 17.8918 13.8253 18.0018 14.0169C18.1119 14.2084 18.3567 14.2751 18.5487 14.1659L18.3495 13.819L18.1502 13.4722ZM24.5407 10.7567C24.7327 10.6475 24.7992 10.4036 24.6891 10.2121C24.5791 10.0205 24.3342 9.95377 24.1422 10.063L24.3415 10.4099L24.5407 10.7567ZM18.3495 13.819L18.5487 14.1659L24.5407 10.7567L24.3415 10.4099L24.1422 10.063L18.1502 13.4722L18.3495 13.819Z",
    fill: "#F4F4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5692 9.7431L24.342 10.4102L23.6193 13.169",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57253 9.9C7.88549 9.9 8.13919 9.64629 8.13919 9.33333C8.13919 9.02037 7.88549 8.76666 7.57253 8.76666C7.25956 8.76666 7.00586 9.02037 7.00586 9.33333C7.00586 9.64629 7.25956 9.9 7.57253 9.9Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83925 9.9C10.1522 9.9 10.4059 9.64629 10.4059 9.33333C10.4059 9.02037 10.1522 8.76666 9.83925 8.76666C9.52629 8.76666 9.27258 9.02037 9.27258 9.33333C9.27258 9.64629 9.52629 9.9 9.83925 9.9Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1059 9.9C12.4188 9.9 12.6725 9.64629 12.6725 9.33333C12.6725 9.02037 12.4188 8.76666 12.1059 8.76666C11.7929 8.76666 11.5392 9.02037 11.5392 9.33333C11.5392 9.64629 11.7929 9.9 12.1059 9.9Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73926 12.1667H16.0726",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6158 17.8333C13.5547 17.8333 14.3158 17.0722 14.3158 16.1333C14.3158 15.1945 13.5547 14.4333 12.6158 14.4333C11.6769 14.4333 10.9158 15.1945 10.9158 16.1333C10.9158 17.0722 11.6769 17.8333 12.6158 17.8333Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6726 17.8333C15.4473 17.8333 16.1635 19.6578 16.3484 20.5997C16.4076 20.901 16.1083 21.1483 15.7327 21.1483H9.61244C9.23686 21.1483 8.9376 20.901 8.99675 20.5997C9.18163 19.6578 9.89789 17.8333 12.6726 17.8333Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAdviserPortal);
export default __webpack_public_path__ + "static/media/CollapseAdviserPortal.04c09baaaf2b4f512fee0a841a38856e.svg";
export { ForwardRef as ReactComponent };